var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('MainNavbar'),_c('v-container',{staticStyle:{"margin-top":"75px","max-width":"1000px"}},[_c('BoardList')],1),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }